// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1kZKY","bigColWidth":"Table_bigColWidth__gN1Sn","biggerColWidth":"Table_biggerColWidth__3Mdvw","row":"Table_row__17LkU","col":"Table_col__3MgGE"};